import {dataExportSvg as Icon__small__dataExportSvg} from '../Icon__small/Icon__small--dataExport.js';
import {dataExportSvg as Icon__xsmall__dataExportSvg} from '../Icon__xsmall/Icon__xsmall--dataExport.js';

export var dataExport = {
  name: 'dataExport',
  category: 'icon',
  colorable: true,
  svg: Icon__small__dataExportSvg,
  alt: {
    Icon__small: Icon__small__dataExportSvg,
    Icon__xsmall: Icon__xsmall__dataExportSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
